import { Grid } from '@material-ui/core';
import { Typography } from '@nutrien/cxp-components';
import React from 'react';

import { useWindowDimensions } from '../../utilities/useWindowDimensions';
import useStyles from '../AssetLocationDetails/AssetLocationDetails.styles';
import { HistoryAreaRiskResultInfo } from '../model/model';

interface Props {
  riskAssessmentData: HistoryAreaRiskResultInfo[];
}

const ShaftRiskAssessment = ({ riskAssessmentData }: Props) => {
  const size = useWindowDimensions();
  const classes = useStyles({ size });
  const Fields = ['category', 'riskRankValue', 'riskAssessmentCategoryName', 'comment'];
  const Label = ['Category', 'Assessed Value', 'Assessment Category', 'Comments'];
  const Category = ['SOC Operations Downtime', 'SOC Fitness-for-Service'];
  const CategoryLabel = ['Severity of Consequence', 'Probability of Failure'];

  const getFieldName = (index: number, data: HistoryAreaRiskResultInfo) => {
    if (
      index === 0 &&
      Category.includes(data[Fields[index] as keyof HistoryAreaRiskResultInfo] as string)
    ) {
      return (data[Fields[index] as keyof HistoryAreaRiskResultInfo] as string).slice(4) || '-';
    } else if (index === 1) {
      return `${data.riskRankValue} - ${data.riskRankName}` || '-';
    }
    return data[Fields[index] as keyof HistoryAreaRiskResultInfo] || '-';
  };

  const getHeading = (category: string) => {
    if (category === Category[0]) {
      return CategoryLabel[0];
    } else if (category === Category[1]) {
      return CategoryLabel[1];
    }
  };

  return (
    <>
      {riskAssessmentData?.map((risk: HistoryAreaRiskResultInfo, index: number) => {
        return (
          <Grid key={index} className={classes.riskAssessmentGrid}>
            <Typography
              variant="subtitle1"
              color="textSecondary"
              fontWeight="normal"
              className="headingText"
            >
              {getHeading(risk.category)}
            </Typography>
            {Label.map((label: string, index2: number) => {
              return (
                <Grid
                  item
                  container
                  xs={12}
                  className={classes.assetProperties}
                  key={`${index}_${label}`}
                >
                  <Grid item xs={12} className={classes.innerBlock}>
                    <Grid item xs={5}>
                      <Typography variant="subtitle1" color="textSecondary" fontWeight="normal">
                        {label}
                      </Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography variant="subtitle1" fontWeight="normal">
                        {getFieldName(index2, risk)}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              );
            })}
            <Grid className={classes.gridBlock} />
          </Grid>
        );
      })}
    </>
  );
};

export default ShaftRiskAssessment;
